/**
 * Utility functions for Laporan Rekap 2 Data Pemantauan Jentik.
 */
import {
  toCount,
  formatPercent,
  averagePercent,
} from "../Rekap1PemantauanJentik/utils";

export { toCount, formatPercent, averagePercent };

export const COUNT_KEYS = [
  "jumlah_tp_disurvei",
  "status_masih_ada",
  "status_tidak_ada",
  "tidak_ada_karena_intervensi",
  "tidak_ada_bukan_karena_intervensi",
  "positif_jentik",
  "negatif_jentik",
  "jarak_lte_100",
  "jarak_gt_100",
  "sifat_permanen",
  "sifat_sementara",
  "air_jernih",
  "air_keruh",
  "ada_tanaman",
  "ada_sampah",
  "terpapar_matahari",
  "air_payau",
  "air_mengalir",
  "ada_ikan",
  "luas_lt_1",
  "luas_1_5",
  "luas_gt_5",
  "kedalaman_lt_1",
  "kedalaman_gte_1",
  "instar_1",
  "instar_2",
  "instar_3",
  "instar_4",
  "pupae",
  "larvasidasi",
  "larv_jenis_biolarvasida",
  "larv_jenis_igr",
  "larv_jenis_organophosphate",
  "larv_jenis_benzoilurea",
  "larv_bentuk_cair",
  "larv_bentuk_bubuk_serbuk",
  "larv_bentuk_granul",
  "larv_bentuk_briket",
  "larv_bentuk_tablet",
  "larv_bentuk_pelet",
  "larv_bentuk_lainnya",
  "penebaran_ikan",
  "modifikasi_lingkungan",
  "manipulasi_lingkungan",
  "intervensi_lainnya",
  "sudah_intervensi",
  "belum_intervensi",
];

/**
 * Calculate indicators for a single row.
 *
 * @param {Object} row
 * @returns {{ cakupan_intervensi: string, indeks_habitat: string }}
 */
export const rowRatios = (row = {}) => {
  const status_masih_ada = toCount(row?.status_masih_ada);
  const positif_jentik = toCount(row?.positif_jentik);
  const sudah_intervensi = toCount(row?.sudah_intervensi);

  return {
    cakupan_intervensi: formatPercent(sudah_intervensi, positif_jentik),
    indeks_habitat: formatPercent(positif_jentik, status_masih_ada),
  };
};

/**
 * Sum metric columns for an array of rows and calculate overall ratios.
 *
 * @param {Array<Object>} rows
 * @returns {Object}
 */
export const sumRows = (rows = []) => {
  const totals = {};
  COUNT_KEYS.forEach((key) => {
    totals[key] = 0;
  });

  rows.forEach((row) => {
    COUNT_KEYS.forEach((key) => {
      totals[key] += toCount(row?.[key]);
    });
  });

  const ratios = rowRatios(totals);

  return {
    ...totals,
    ...ratios,
  };
};
